var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 11H8.4l2.9-2.9c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-4.6 4.6c-.4.4-.4 1 0 1.4l4.6 4.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L8.4 13H18c.6 0 1-.4 1-1s-.4-1-1-1z"}));
}

LeftArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
